import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import LinkWithPopover from './link-with-popover';
import money, { format } from '../lib/money';
import '../css/currency-conversion.css';

class CurrencyConversion extends Component {
  renderBreakdown() {
    const { processingCurrencyCode, currencyCode, conversionRate, amount } = this.props;
    const exchangeRate = parseFloat(conversionRate, 10);
    const convertedAmount = money(amount.amountCents, processingCurrencyCode).convert(exchangeRate);

    return (
      <div className="exchange-popover">
        <p>
          <FormattedMessage
            id="currencyConversion.rate"
            defaultMessage="Conversion rate when charged"
          />
        </p>
        <p>
          <span>
            1 {currencyCode.toUpperCase()}
            {' '} = {' '}
            {`${exchangeRate.toLocaleString()} ${processingCurrencyCode.toUpperCase()}`}
          </span>
        </p>
        <p>
          <FormattedMessage
            id="currencyConversion.amount"
            defaultMessage="Amount charged"
          />
        </p>
        <p><span>{processingCurrencyCode.toUpperCase()} {format(convertedAmount)}</span></p>
      </div>
    );
  }

  render() {
    if (!this.props.conversionRate) return null;

    return (
      <LinkWithPopover
        name="currency-conversion"
        text={<i className="fa fa-exchange" />}
        placement="bottom"
        className="currency-conversion"
      >
        {this.renderBreakdown()}
      </LinkWithPopover>
    );
  }
}

export default CurrencyConversion;



// WEBPACK FOOTER //
// ./src/desktop/components/currency-conversion.js